<script>
  import { NEXT, PREV } from '../../direction'

  /**
   * Indicates direction of the arrow ('next', 'prev')
   */
  export let direction = NEXT

  /**
   * Indicates if button disabled
   */
  export let disabled = false
</script>

<div
  class="swiper-button-white"
  class:swiper-button-disabled={disabled}
  class:swiper-button-next={direction === NEXT}
  class:swiper-button-prev={direction === PREV}
  on:click
>
</div>

